// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"QuotePreview_fadeIn__TTj_v","animate-fadeIn":"QuotePreview_animate-fadeIn__T2lJW"};